import { useLang } from "@/contexts/LanguageContext";
import { CLIENTS } from "@/data/clients";

const ClientsMarquee = () => {
  const { t } = useLang();
  const repeated = [...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS];

  return (
    <section data-testid="clients-marquee" className="pt-16 md:pt-20 pb-16 md:pb-20 bg-bg">
      {/* Small uppercase title above the wine band, matching the "Lo más pedido" overline style */}
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 mb-4 md:mb-5 text-center">
        <h2
          data-testid="clients-marquee-title"
          className="text-[11px] md:text-xs uppercase tracking-[0.3em] text-caramel font-medium"
        >
          {t.home.clientsOverline}
        </h2>
      </div>

      {/* Narrow wine band with logos */}
      <div className="bg-wine relative overflow-hidden border-t border-b border-wine-hover">
        <div className="flex whitespace-nowrap animate-marquee-slow items-center gap-16 md:gap-24 py-6 md:py-8">
          {repeated.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              data-testid={`client-logo-${i}`}
              className="flex-shrink-0 flex items-center justify-center h-10 md:h-12 opacity-95 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src={c.src}
                alt={c.name}
                className="max-h-full w-auto object-contain"
                draggable={false}
              />
            </div>
          ))}
        </div>
        {/* Edge fades to wine */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-wine to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-wine to-transparent" />
      </div>
    </section>
  );
};

export default ClientsMarquee;
